import msgs from './reducers'

export { addMsg, removeMsg } from './actions'

export { getMessages } from './selectors'

export default msgs
